export class PopUpState {
    constructor(title, subtitle, isCancelVisible, onCancelListener, onSuccessListener, onOutSideClick) {
        this.title = title;
        this.subtitle = subtitle;
        this.isCancelVisible = isCancelVisible;
        this.onCancelListener = onCancelListener;
        this.onSuccessListener = onSuccessListener;
        this.onOutSideClick = onOutSideClick;
    }
}